/* global System */
export default (path = '/') =>
  (name, noCss) =>
    Promise.all([
      window.mqConfig.bwCompat
        ? System.import(`${path}rp-assets/js/${window.mqScripts?.['extra.js'] || 'extra.js'}`)
        : import(`${path}rp-assets/js/${window.mqScripts?.['extra.mjs'] || 'extra.mjs'}`)
    ]).then(([module]) => module)
